export const SET_YEAR = 'setYear'
export const GET_TRAININGS = 'getTrainings'
export const SET_TRAINING = 'setTraining'
export const GET_SUBJECTS = 'getSubjects'
export const SET_SUBJECTS = 'setSubjects'
